import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'cuponesEC',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }
    }
  },
  computed: {
    reporte: function () {
      return '/reportes/liquidaciones/natura?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta + '&estado=' + this.f_c.estado
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  unmounted() {
    this.tbv.destroy();
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");


    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      'rowCallback': function (row, data, index) { },
    });
    $('.box').boxWidget();
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/liquidaciones/natura', this.f_c)
        .then(response => {
          response.data.data.forEach(element => {
            element[7] = this.num_to_many(element[7]);
            element[8] = this.num_to_many(element[8]);
            element[9] = this.num_to_many(element[9]);
            element[10] = this.num_to_many(element[10]);
            element[11] = this.num_to_many(element[11]);
            element[12] = this.num_to_many(element[12]);
            element[13] = this.num_to_many(element[13]);
            element[14] = this.num_to_many(element[14]);
            element[15] = this.num_to_many(element[15]);
            this.tbv.row.add(element);
          });

          this.tbv.draw();
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/liquidacionesNatura/index.js